export type ContentQueryParams = {
  id?: string;
  storeName: any;
}
